import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getMembershipStats = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_MEMBERSHIP_STATS,
    payload: paramObj,
    meta: {
        type: 'apijson',
        url: baseUrl + '/membership_stats',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
        },
        options: {
            method: 'GET'
        }
    }
})

